import { RawDataSource } from '@felicity/data-management';

/**
 * Data source for loading and storing assessment tool owners
 */
export default class OwnerDataSource extends RawDataSource {
  uri = '/api/Users/Profile/Selector';
  sortField = 'name';

  /**
   *
   */
  constructor() {
    super();

    this.setFilter('role', 'owner');
  }
}
